/* ==========================================================================
   Rook UI Core — Accordion Controller
   Web Component: <rk-accordion-element>
   ========================================================================== */

if (!customElements.get('rk-accordion-element')) {
    class RkAccordionElement extends HTMLElement {
        constructor() {
            super();
            this.details = null;
            this.content = null;
            this.animation = null;
            this.isClosing = false;
            this.isExpanding = false;
        }

        connectedCallback() {
            this.details = this.querySelector('details');
            this.content = this.querySelector('.rk-accordion__content');

            if (!this.details || !this.content) return;

            const summary = this.details.querySelector('summary');
            if (summary) {
                summary.addEventListener('click', (e) => this.onClick(e));
            }
        }

        onClick(e) {
            e.preventDefault();

            this.details.style.overflow = 'hidden';

            if (this.isClosing || !this.details.open) {
                this.open();
            } else if (this.isExpanding || this.details.open) {
                this.shrink();
            }
        }

        shrink() {
            this.isClosing = true;

            const startHeight = `${this.details.offsetHeight}px`;
            const summary = this.details.querySelector('summary');
            const endHeight = `${summary.offsetHeight}px`;

            if (this.animation) {
                this.animation.cancel();
            }

            this.animation = this.details.animate(
                { height: [startHeight, endHeight] },
                { duration: 200, easing: 'ease-out' }
            );

            this.animation.onfinish = () => this.onAnimationFinish(false);
            this.animation.oncancel = () => (this.isClosing = false);
        }

        open() {
            this.details.style.height = `${this.details.offsetHeight}px`;
            this.details.open = true;

            window.requestAnimationFrame(() => this.expand());
        }

        expand() {
            this.isExpanding = true;

            const startHeight = `${this.details.offsetHeight}px`;
            const summary = this.details.querySelector('summary');
            const endHeight = `${summary.offsetHeight + this.content.offsetHeight}px`;

            if (this.animation) {
                this.animation.cancel();
            }

            this.animation = this.details.animate(
                { height: [startHeight, endHeight] },
                { duration: 200, easing: 'ease-out' }
            );

            this.animation.onfinish = () => this.onAnimationFinish(true);
            this.animation.oncancel = () => (this.isExpanding = false);
        }

        onAnimationFinish(open) {
            this.details.open = open;
            this.animation = null;
            this.isClosing = false;
            this.isExpanding = false;
            this.details.style.height = '';
            this.details.style.overflow = '';
        }
    }

    customElements.define('rk-accordion-element', RkAccordionElement);
}
